import axios from "@/util/axios";

const PREFIX_URI = "/order/stock/query";

export default {
    /** 分页查询总库存（按商品，od_stock） */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 分页查询批次库存（按批次，od_stock_batch） */
    queryBatchList: (data) => axios.get({url: `${PREFIX_URI}/queryBatchList`, data}),
    /** 查询商品在仓库的有效批次（批次弹窗） */
    queryBatchByProduct: (warehouseId, productId, skuId) => axios.get({url: `${PREFIX_URI}/queryBatchByProduct`, data: {warehouseId, productId, skuId}}),
    /** 查询库存变更记录 */
    queryLog: (data) => axios.get({url: `${PREFIX_URI}/queryLog`, data}),
    /** 查询批次详情（路桥定制：小程序扫批次码） */
    findBatchById: (id) => axios.get({url: `${PREFIX_URI}/findBatchById`, data: {id}}),
    /** 按仓库+堆料区查询批次（路桥定制：扫货区码选商品） */
    queryBatchByArea: (warehouseId, warehouseAreaId) => axios.get({url: `${PREFIX_URI}/queryBatchByArea`, data: {warehouseId, warehouseAreaId}}),
    /** 生成批次二维码（路桥定制：已有的跳过） */
    updateBatchQrCode: (ids) => axios.post({url: `${PREFIX_URI}/updateBatchQrCode`, data: ids}),
}
